<style lang="scss" src='./GolfCourse.scss' scoped></style>
<template src="./GolfCourse.html"></template>

<script>
import SecurityComponent from '@/components/SecurityComponent.vue';
import Placeholder from '@/components/placeholders/Placeholders.vue';
import {
  uploadGolfImages,
  deleteBackgroundImage,
} from '@/api/index';

import {
  mapState,
  mapActions,
  mapMutations,
} from 'vuex';

export default {
  name: 'GolfCourse',
  extends: SecurityComponent,
  components: {
    Placeholder,
  },
  data() {
    return {
      create: true,
      tempImages: [],
      isOperationsOrAdminUser: false,
      tempLogo:{
        file: null,
        name: null,
      }
    };
  },
  computed: {
    ...mapState('Settings', ['golfCourse', 'loading']),
  },
  methods: {
    ...mapActions('Settings', ['apiGetCourse', 'apiUpdateCourse']),
    ...mapMutations('Settings', ['addBackgroundPhoto', 'setLoading']),
    ...mapActions(['changeBackground', 'updateUserCourse']),

    async onSubmit() {
      this.setLoading({ updateData: true });
      await this.uploadLogo();
      if (this.tempImages.length > 0) {
        await this.uploadTempPhotos();
      }
      await this.deleteImages();

      let currentCourse = {...this.golfCourse};
        
      delete this.golfCourse.facility_notes;
      delete this.golfCourse.shop_address;

      if(!this.isOperationsOrAdminUser){
        delete this.golfCourse.measurement_system;
        delete this.golfCourse.course_code;
        delete this.golfCourse.name;
      }

      await this.apiUpdateCourse();
      this.golfCourse = currentCourse;

      this.tempImages = [];

      this.updateUserCourse({...this.golfCourse});
      this.changeBackground();
    },

    deleteTempImage(index) {
      this.tempImages.splice(index, 1);
    },

    async uploadTempPhotos() {
      for (let image of this.tempImages) {
        const formData = new FormData();
        formData.append('background', image.file, image.name);
        await uploadGolfImages(null, formData, 'background')
          .then((res) => res.data.data)
          .then((res) => {
          }).catch(() => {});
      }
    },

    async deleteImages() {
      for (let image of this.golfCourse.background_images) {
        if(image.deleted === true) {
          await deleteBackgroundImage( image.image_id ).then((res) => {
          }).catch(() => {});
        }
      }
    },
    
    newPhoto(event) {
      const file = event.target.files[0];
      if (this.G_validateImage(file)) {
        var name = event.target.files[0].name;
        var reader = new FileReader();
        reader.onloadend = ((event) => {
          let newImage = {
            name,
            file,
            image: event.target.result,
          };
          this.tempImages.push(newImage);
          document.getElementById("uploadPhoto").value = '';
        });
        reader.readAsDataURL(file);
      }
    },

    onLogoChanged(event) {
      this.G_createUrlFromFile(event, (mImage)=> {
          this.tempLogo = mImage;
          this.golfCourse['logo_url'] = mImage.url;
      });
    },

    async uploadLogo(){
      if( this.tempLogo.file == null ){
        return true;
      }
      const formData = new FormData();
      const type = 'logo';
      formData.append(type, this.tempLogo.file, this.tempLogo.name);
      await uploadGolfImages(null, formData, type, null)
        .then((res) => res.data.data)
        .then((course) => {
          if (course && course.logo_url) {
            this.golfCourse['logo_url'] = course.logo_url;
          }
        });
    },
  },
  async mounted() {
    if (process.env.VUE_APP_SENTRY_ENV == "production") {
      this.$analytics.setCurrentScreen("Web Settings Golf Course");
      this.$analytics.logEvent("web_settings_golf_course");
    }

    if (this.$store.state.user.user_type.type_id == this.consts.UserType.ADMIN ||
      this.$store.state.user.user_type.type_id == this.consts.UserType.OPERATIONS){
      this.isOperationsOrAdminUser = true;
    }else{
      this.isOperationsOrAdminUser = false;
    }

    this.create = false;
    this.apiGetCourse();
  },
};

</script>
